import React from 'react';

interface MeasureTokenTextProps {
  text: string;
  labelPrefix?: string;
}

function buildLabel(text: string, labelPrefix: string): string {
  const collapsed = text.replace(/\s+/g, ' ').trim();
  if (!collapsed) return `${labelPrefix} Token`;
  if (collapsed.length <= 48) return `${labelPrefix} Token: ${collapsed}`;
  return `${labelPrefix} Token: ${collapsed.slice(0, 48)}…`;
}

export const MeasureTokenText: React.FC<MeasureTokenTextProps> = ({
  text,
  labelPrefix = 'Text',
}) => {
  const parts = text.split(/(\s+)/).filter((part) => part.length > 0);
  return (
    <>
      {parts.map((part, index) => {
        if (/^\s+$/.test(part)) return part;
        return (
          <span
            key={`${part}-${index}`}
            className="markdown-measure-token"
            data-measure-token="inline-word"
            data-measure-label={buildLabel(part, labelPrefix)}
          >
            {part}
          </span>
        );
      })}
    </>
  );
};

